// shared/src/schemas/amm-snapshot.ts
// Zod schema for `amm_snapshots` table (D1 migration 0001_init.sql:118-122).
// 3 columns; A2 drift-detector enforces field-name parity.

import { z } from 'zod';

export const AmmSnapshotSchema = z.object({
  id:         z.string(),
  created_at: z.string().datetime(),
  payload:    z.string(),    // JSON: { positions[], price_history[], benchmark, pools[], categories[] }
});

export type AmmSnapshot = z.infer<typeof AmmSnapshotSchema>;
